import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const sentryDsn = import.meta.env.SENTRY_DSN || import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
  });
} else if (import.meta.env.PROD) {
  console.warn("[ScribPost] SENTRY_DSN not set — frontend error monitoring is disabled");
}

createRoot(document.getElementById("root")!).render(<App />);
